import React from 'react'

class Schedule extends React.Component {
  CLOSED = '／'
  OPEN = '〇'
  render() {
    return (
      <div className="content-container" id="schedule">
        <div className="content-title">診察日＆時間</div>
        <div className='schedule-table-wrapper'>
        <table className="table">
          <tbody>
          <tr>
            <th>受付時間</th>
            <th className='sunday-color'>日</th>
            <th>月</th>
            <th>火</th>
            <th>水</th>
            <th>木</th>
            <th>金</th>
            <th className='saturday-color'>土</th>
          </tr>
          <tr>
            <td className='table-time'>9:30~11:30</td>
            <td className='closed-color'>{this.CLOSED}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='closed-color'>{this.CLOSED}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='open-color'>{this.OPEN}※</td>
          </tr>
          <tr>
            <td className='table-time'>15:30~17:30</td>
            <td className='closed-color'>{this.CLOSED}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='closed-color'>{this.CLOSED}</td>
            <td className='open-color'>{this.OPEN}</td>
            <td className='closed-color'>{this.CLOSED}</td>
          </tr>
          </tbody>
        </table>
        <div style={{textAlign: "right"}}>※第4土曜日は休診</div>
        </div>
      </div>
    )
  }
}

export default Schedule

